import ToastNotificacion from "../notificaciones/ToastNotificacion";
export default function CardCorte({children}) {
    //flex-column-fluid
    return (
        <>
            <ToastNotificacion></ToastNotificacion>
            <div className="d-grid d-md-flex align-items-center justify-content-center">
                <div className='content d-flex flex-column p-8 flex-fill'>
                    {/*<div className={'card card-bordered d-flex flex-row-fluid flex-center'}>*/}
                        {children}
                    {/*</div>*/}
                </div>
            </div>
        </>
    );
}
